import {
  ApplicationHeader,
  Cell,
  LogoProps,
  styled,
} from '@zeiss/beyond-online-react';

import { ErrorStateComponent, ErrorStateProps } from './ErrorStateComponent';
import { Container } from 'src/components/Grid';
import { FullPageLayout } from 'src/components/layouts';

const StyledInnerGrid = styled(Container.InnerGrid)`
  padding-top: var(--spacing-l);

  /* Remove gap on mobile screens so that the empty Cell.Basic do not affect layout spacing */
  && {
    gap: 0;

    @media (width >= 768px) {
      gap: 0;
    }

    @media (width >= 1024px) {
      gap: 1.5rem;
      padding-top: var(--spacing-xl);
    }
  }

  /* Reset overflow, so that cards are rendered correctly with their box shadow */
  && {
    overflow: visible;
  }
`;
interface FullPageError {
  footer: React.ReactNode;
  fullPageLayout: true;
  onBackToHomeClick: LogoProps['onClick'];
  productTitle: string;
}

interface NonFullPageError {
  footer?: never;
  fullPageLayout?: false;
  onBackToHomeClick?: never;
  productTitle?: never;
}

type LayoutProps = FullPageError | NonFullPageError;

export const ErrorState = (props: ErrorStateProps & LayoutProps) => {
  const { fullPageLayout } = props;

  if (fullPageLayout) {
    const { footer, onBackToHomeClick, productTitle } = props;

    return (
      <FullPageLayout
        footer={footer}
        header={
          <ApplicationHeader
            applicationTitle={productTitle}
            logo={{
              onClick: onBackToHomeClick,
            }}
            shellLayout="with-side-nav"
          />
        }
      >
        <StyledInnerGrid>
          <Cell.Basic colSpan={[4, 1, 3]} />
          <Cell.Basic colSpan={[4, 4, 6]}>
            <ErrorStateComponent {...props} />
          </Cell.Basic>
          <Cell.Basic colSpan={[4, 1, 3]} />
        </StyledInnerGrid>
      </FullPageLayout>
    );
  }

  return <ErrorStateComponent {...props} />;
};
